import { ManageAssetsTabController } from './manage-assets-tab-access.controller'

function manageAssetsTabAccess () {
  return {
    restrict: 'E',
    scope: {
      assets: '<',
      form: '=',
      flags: '='
    },
    templateUrl: '/repository/directives/manage-assets-tab-access/manage-assets-tab-access-directive.html?$$REVISION$$',
    controller: ManageAssetsTabController
  }
}

export { manageAssetsTabAccess }
